'use client';

import type { ReactNode } from 'react';
import { MinimalToolCard } from '../../MinimalToolCard';
import type { CardRenderContext } from '../../tool-config-types';
import { VegaLiteChart } from './vega-lite-chart';
import { readVegaLiteVisualizationCached } from './vega-lite-visualization.utils';

export const renderVegaLiteVisualizationCard = (
  ctx: CardRenderContext,
): ReactNode => {
  const visualization = readVegaLiteVisualizationCached(
    ctx.toolCallData.output,
    ctx.toolCallData.input,
  );
  const canShowChart =
    ctx.toolCallData.status === 'completed' && Boolean(visualization);

  if (canShowChart && visualization) {
    return (
      <VegaLiteChart
        spec={visualization.spec}
        description={visualization.description}
      />
    );
  }

  const durationMs = ctx.toolCallData.timing?.durationMs;

  return (
    <MinimalToolCard
      icon={ctx.toolIcon}
      toolName={
        ctx.toolCallData.status === 'started' ||
        ctx.toolCallData.status === 'in-progress'
          ? ctx.labelPresent
          : ctx.labelPast
      }
      status={ctx.toolCallData.status}
      timing={typeof durationMs === 'number' ? { durationMs } : undefined}
      error={ctx.toolCallData.error}
      autoCollapseWhenComplete={ctx.autoCollapseWhenComplete}
    />
  );
};
